
import React from 'react'
import { Input, Button, Space, Select, Popover, Tabs } from 'antd';
import Card from '../com/partTimeJob/card';
import Config from "../../config/Config";
import EventBus from "../../frame/eventBus";
import WidgetAjax from '../../widget/WidgetAjax';

import { checkLogin, tagRedirect } from '../../pages/com/utils';
import { CaretDownOutlined } from '@ant-design/icons';
import JobType from '../home/com/JobType';
let path = Config.getBasePath();
let Application = Config.getApplication();
let getCareerUrl = Config.getCareerUrl();
class partTimeJob extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeFilter: [
        { label: "坐班", value: '1' },
        { label: "居家", value: '2' },
      ],
      typeFilterValue: '1',
      jobTypeLoading: true,
      bannerList: [
        { icon: require("../../img/pinzhunzhun/PartTimeJob/banner1.png"), onClick: () => this.toSearch({ JOBTYPE: '010101',WORKPLACE:undefined }) },
        { icon: require("../../img/pinzhunzhun/PartTimeJob/banner2.png"), onClick: () => this.toSearch({ JOBTYPE: '080101',WORKPLACE:undefined }) },
        { icon: require("../../img/pinzhunzhun/PartTimeJob/banner3.png"), onClick: () => this.toSearch({ JOBTYPE: '050101',WORKPLACE:undefined }) },
      ],

      screenType: [
        { title: "热门零工岗位", title_html: <><div style={{ color: '#3D413E' }}>热门</div>零工岗位</>, tips: '做做兼职更富裕', name: "hot_internship", img: require("../../img/pinzhunzhun/dataSource/icon_hot_internship.png") },
        { title: '热门零工行业', title_html: <><div style={{ color: '#3D413E' }}>热门</div>零工行业</>, name: "hot_ent", img: require("../../img/pinzhunzhun/dataSource/icon_hot_ent.png") }],
      jobData: [],
      TabsData: [
        {
          key: "0",
          label: `全部`,
        },
        {
          key: "11",
          label: `坐班`,
        },
        {
          key: "12",
          label: `居家`,
        },
      ],
      tabsValue: '0'
    }
  }
  async componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let userInfo = sessionStorage.getItem("_user_info_");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      let location = JSON.parse(sessionStorage.getItem("_user_location_"));
      await this.setState({ userInfo: userInfo, location });

    }
    if (params) {
      // 获取指定参数的值
      const param1 = params.get('param1');
      const param2 = params.get('param2');
    }
    this.jobTypeList();
    this.jobList();
    this.entSearch();
    if (sessionStorage.getItem("_user_access_")) {
      this.getUserInfo();
    }
    EventBus.on('locationChange', this.locationChange);
    this.hotList();
  }

  componentWillUnmount() {
    EventBus.off('locationChange', this.locationChange);
  }

  locationChange = async (location) => {
    await this.setState({ location });
    this.hotList();
    this.jobList();
    this.entSearch();
  }

  componentWillReceiveProps() {
    let userInfo = sessionStorage.getItem("_user_info_");

    if (userInfo) {
      userInfo = JSON.parse(userInfo);

      this.setState({ userInfo: userInfo });
    }
  }

  getUserInfo = () => {

    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }

    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }

  /**
  * 热词
  */
  hotList = () => {
    const { location } = this.state;
    let params = {
      // type: 'campus',
      // category: '03',
      // search_type: 'job',
      // district: location?.value
      DISTRICT: location?.value,
      type: 'job' ,
      limit:6
    }
    const onHotList = (res) => {
      if (res.status == 0) {
        this.setState({ hotData: res.results });
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/search_hot',
      params,
      callback: onHotList
    });
  }




  jobTypeList = async () => {
    await this.setState({ jobTypeLoading: true });
    const onJobTypeList = (res) => {
      if (res.status === 0) {
        if (res.results && res.results.length) {
          let jobTypeData = res.results.filter((item) => item.name !== "常用岗位");
          this.setState({ jobTypeData });
        }
        this.setState({ jobTypeLoading: false });
      }
    };
    WidgetAjax.ajax({
      url: path + '/recruitment/job_type',
      params: { parent_code: "0" },
      callback: onJobTypeList
    });
  }



  jobList = () => {
    const { location, tabsValue } = this.state;
    let params = {
      // type: 'campus',
      JOBCATEGORY:"1",
      PROPERTY:['12','13'],
      WORKPLACE: tabsValue && tabsValue!='0'? [tabsValue] :undefined,
      page: 1, records: 9,
      DISTRICT: location ? [location?.value] : [],
      // query: "*"
    }
    const onJobList = (res) => {
      if (res.status == 0) {
        this.setState({ jobData: res.results });
      }
    }
    WidgetAjax.ajax({ url: path + '/job/search', params, callback: onJobList });
  }



  entSearch = () => {
    const { location } = this.state;
    const onEntSearch = (res) => {
      if (res.status == 0) {
        if (res.results && res.results.length > 0) {
          let entData = res.results.map((item) => {
            return { ...item }
          })
          this.setState({ entData });

        } else {
          this.setState({ entData: [] })
        }
      }
    }
    WidgetAjax.ajax({
      url: path + '/recommend/flexi_job_type',
      params: {
        type: 'campus',
        DISTRICT: location ? [location?.value] : undefined,
       
      },
      callback: onEntSearch
    });
  }


  RedirectTo = (link) => {
    const accessToken = sessionStorage.getItem('_user_access_');
    const encodedToken = btoa(accessToken);
    const signature = btoa(accessToken + Application);
    window.open(`${getCareerUrl}/tokenLogin?token=${encodedToken}&sig=${signature}&link=${link}`, '_blank');
  }


  aiChat = (type) => {
    if (checkLogin()) {
      this.props.history.push({ pathname: "/home/ai-chat", state: { scene: type } });
    } else {
      this.logOut("/home/ai-chat", { scene: type });
    }
  }

  logOut = (URL, state) => {
    this.props.history.push({ pathname: URL ? '/login?redirectURL=' + URL : "/login", state });
    window.location.reload();

  }

  tabsChange = async (value) => {
    await this.setState({ tabsValue: value });
    this.jobList();
  }

  screenType = (obj) => {
    const { jobData, entData, TabsData } = this.state;
    let children = <div className='tabs_box'>
      <Tabs items={TabsData} onChange={this.tabsChange} />
    </div>
    switch (obj?.title) {
      case "热门零工岗位":
        return <Card obj={obj} data={jobData} type={'job'} history={this.props.history} children={children} />
      case "热门零工行业":
        return <Card obj={obj} data={entData} type={'ent'} history={this.props.history} />
      default:
        return "暂无"
    }


  }

  tagRedirect = () => {
    const currentUrl = window.location.href;
    const homeIndex = currentUrl.indexOf('home/');
    if (homeIndex !== -1) {
      let newUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
      const params = new URLSearchParams();
      newUrl = newUrl + 'profession'
      let urlWithParams = `${newUrl}?${params.toString()}`;
      window.open(urlWithParams, '_blank');
    }
  }

  toSearch = (obj) => {
    const { word, typeFilterValue } = this.state;
    tagRedirect({ PROPERTY: '2,3', WORKPLACE: typeFilterValue, word, ...obj }, "partTimeSearch")
  }



  notify = (tab) => {
    if (checkLogin()) {
      if (tab === '5') {
        this.props.history.push({ pathname: "/home/resume" });
      } else if (tab === '6') {
      } else {
        this.props.history.push({ pathname: "/home/applicant", state: { tab } });
      }
    } else {
      let url;
      let state;
      switch (tab) {
        case "5":
          url = "/home/resume";
          break;
        case "6":
          break;
        default:
          url = "/home/applicant";
          state = { tab };
          break;
      }

      this.logOut(url, state);
    }
  }
  profession = (type) => {
    console.log(type);
    this.props.history.push({
      pathname: "/home/profession/detail",
      state: { name: type }
    });
  }

  setWork = async (value) => {
    await this.setState({ searchValue: value });
    this.toSearch()
  }

  onType = async (value) => {
    await this.setState({ typeFilterValue: value });
  }

  render() {
    const { word, jobTypeData, typeFilter, typeFilterValue, bannerList, screenType, jobTypeLoading, hotData } = this.state;

    return <div component-data="partTimeJob">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200 '>
            <div className='head_filter_box'>
              <img className='home_logo' src={require("../../img/pinzhunzhun/dataSource/partTimeJob_icon.svg")} />
              <div className='search_home'>
                <div className='search_box'>
                  <Space.Compact style={{ width: '100%' }}>
                    <Select defaultValue="岗位" options={typeFilter} value={typeFilterValue} onChange={(value) => this.onType(value)} dropdownStyle={{ width: "86px" }} suffixIcon={<CaretDownOutlined />} />
                    <Input placeholder="搜索职位关键词" value={word} onChange={(e) => { this.setState({ word: e.target.value }) }} />
                    <Button type="primary" onClick={() => { this.toSearch() }} >搜索</Button>
                  </Space.Compact>
                  <img className='ai_recommendation'
                    onClick={() => { this.aiChat("岗位推荐") }}
                    src={require("../../img/pinzhunzhun/dataSource/ai_recommendation.png")} />
                </div>
                <div className='hot_jobType'>
                  <label> 热门搜索: </label>
                  {
                    hotData && hotData.map((item) => {
                      return <div className='hot_item' onClick={() => this.setWork(item.word)}> {item.word}</div>
                    })
                  }
                </div>
              </div>
              <div className='board_qrCode' >
                {/* <Popover placement="right"  content={<img className='codeImg' src={require("../../img/pinzhunzhun/dataSource/public_code.png")} />}>
                  <a>扫码进公众号</a>
                </Popover> */}
                {/* <Popover placement="right"  content={<img className='codeImg' src={require("../../img/pinzhunzhun/dataSource/applet.png")} />}>
                  <a>扫码进求职招聘小程序</a>
                </Popover> */}
              </div>
            </div>
          </div>
        </div>

        <div className='box_1200 ' style={{ paddingTop: '150px' }}>

          <div className='box_banner'>

            <JobType data={jobTypeData} loading={jobTypeLoading} options={{ records: 10 }} />
            <div className='job_banner'>
              <div className='template1'>
                <img className='template1_01' onClick={() => { this.RedirectTo('career-seek') }} src={require("../../img/pinzhunzhun/PartTimeJob/banner_01.png")} />
                <div>
                  {
                    bannerList.map((item, index) => {
                      return <div onClick={item?.onClick}>
                        <img className='template1_02' src={item?.icon} />
                      </div>
                    })
                  }
                </div>
              </div>
              <div className='template2' onClick={() => { this.RedirectTo('career-planning') }}>
                <img className='template' src={require("../../img/pinzhunzhun/PartTimeJob/banner_02.png")} />
              </div>
            </div>
          </div>
          <div className='omnibus'>
            {
              screenType.map((item) => {
                return this.screenType(item);
              })
            }
          </div>
        </div>
      </div>
    </div>
  }
}

export default partTimeJob;